import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { FormattedMessage, InjectedIntl, injectIntl } from 'react-intl';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import Checkbox from '../components/Checkbox';
import ValidationErrors from './validationErrors';

interface ICheckboxFieldProps {
    id: string;
    label: FormattedMessage.MessageDescriptor | string;
    intl: InjectedIntl;
    value?: boolean;
    required?: boolean;
    tooltipText?: FormattedMessage.MessageDescriptor | string;
}

interface ICheckboxFieldState {
    checked: boolean;
}

class CheckboxField extends React.Component<ICheckboxFieldProps, ICheckboxFieldState> {
    private readonly ID: string;

    constructor(props: ICheckboxFieldProps) {
        super(props);
        const { id, value } = this.props;

        this.state = {
            checked: Boolean(value),
        };
        this.ID = id;
        this.validate = this.validate.bind(this);
        this.renderCheckboxField = this.renderCheckboxField.bind(this);
    }

    componentDidUpdate(prevProps: Readonly<ICheckboxFieldProps>): void {
        if (prevProps.value !== this.props.value) {
            this.setState({ checked: Boolean(this.props.value) });
        }
    }

    public render() {
        return <Field name={this.ID} validate={this.validate} render={this.renderCheckboxField} />;
    }

    private validate(value: string): string {
        const { intl, required } = this.props;

        if (!value && required) {
            return ValidationErrors.fieldRequiredMessage(intl, '');
        }

        return '';
    }

    private renderCheckboxField({
        field,
        form: { touched, errors, setFieldValue },
    }: FieldProps): ReactNode {
        const { label, intl, value, required, tooltipText } = this.props;
        const { checked } = this.state;
        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        const labelMessage: string = TranslationHelpers.isMessageDescriptor(label)
            ? intl.formatMessage(label)
            : label;
        const toggleValue = (() => {
            this.setState({ checked: !checked });
            setFieldValue(this.ID, !checked);
        }).bind(this);

        return (
            <Checkbox
                id={this.ID}
                name={this.ID}
                ariaLabel={labelMessage}
                label={labelMessage}
                value={checked}
                onChange={toggleValue}
                tooltipText={tooltipText}
            />
        );
    }
}

export default injectIntl(CheckboxField);
